import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isNil from "lodash/isNil";
import "core-js/modules/es6.set.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
import { permissions } from 'const';
var accessRoles = {
  OWNER: 'owner',
  EXPLORER: 'explorer',
  VIEWER: 'viewer',
  ADMIN: 'admin',
  READ_ONLY_ADMIN: 'readOnlyAdmin'
};
var permissionsByRole = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, accessRoles.OWNER, new Set([permissions.WRITE, permissions.READ_USER_ACCESS])), accessRoles.EXPLORER, new Set([permissions.WRITE, permissions.READ_USER_ACCESS])), accessRoles.VIEWER, new Set([])), accessRoles.ADMIN, new Set([permissions.WRITE, permissions.READ_USER_ACCESS])), accessRoles.READ_ONLY_ADMIN, new Set([]));
var getRole = function getRole(state, projectId, projectType) {
  var _state$experiments$pr;
  if (projectType === 'secondaryAnalysis') {
    var _state$secondaryAnaly;
    return (_state$secondaryAnaly = state.secondaryAnalyses[projectId]) === null || _state$secondaryAnaly === void 0 ? void 0 : _state$secondaryAnaly.accessRole;
  }
  return _isNil(projectId) ? state.experimentSettings.info.accessRole : (_state$experiments$pr = state.experiments[projectId]) === null || _state$experiments$pr === void 0 ? void 0 : _state$experiments$pr.accessRole;
};
var getHasPermissions = function getHasPermissions(projectId, permissionsToCheck) {
  var projectType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'experiment';
  return function (state) {
    var _permissionsByRole$ro, _permissionsByRole$ro2;
    var role = getRole(state, projectId, projectType);
    return (_permissionsByRole$ro = (_permissionsByRole$ro2 = permissionsByRole[role]) === null || _permissionsByRole$ro2 === void 0 ? void 0 : _permissionsByRole$ro2.has(permissionsToCheck)) !== null && _permissionsByRole$ro !== void 0 ? _permissionsByRole$ro : false;
  };
};
export default createMemoizedSelector(getHasPermissions);
export { accessRoles };